module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-actions', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.saveGruppen()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l((_vm.gruppen.gruppen), function(gruppe, index) {
    return _c('v-col', {
      key: index,
      staticClass: "px-1",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-title', [_c('v-text-field', {
      attrs: {
        "outlined": "",
        "dense": "",
        "hide-details": "",
        "label": index + 1 + '. Ordner'
      },
      model: {
        value: (gruppe.titel),
        callback: function($$v) {
          _vm.$set(gruppe, "titel", $$v)
        },
        expression: "gruppe.titel"
      }
    })], 1), _vm._v(" "), _c('v-expansion-panels', {
      staticClass: "elevation-0 pa-6 pt-0"
    }, [_c('draggable', {
      staticClass: "v-item-group theme--light v-expansion-panels",
      attrs: {
        "group": "myGroup"
      },
      on: {
        "change": function($event) {
          return _vm.saveGruppen()
        }
      },
      model: {
        value: (gruppe.gruppen),
        callback: function($$v) {
          _vm.$set(gruppe, "gruppen", $$v)
        },
        expression: "gruppe.gruppen"
      }
    }, _vm._l((gruppe.gruppen), function(item, index2) {
      return _c('v-expansion-panel', {
        key: index2
      }, [_c('v-expansion-panel-header', {
        staticClass: "py-0 pl-0",
        attrs: {
          "expand-icon": "edit",
          "disable-icon-rotate": ""
        }
      }, [_c('v-list', {
        staticClass: "pa-0",
        attrs: {
          "dense": ""
        }
      }, [_c('v-list-item', {
        staticClass: "pa-0"
      }, [_c('v-list-item-avatar', {
        staticClass: "my-0"
      }, [_c('v-icon', [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "py-0"
      }, [_c('v-list-item-title', {
        domProps: {
          "innerHTML": _vm._s(item.text)
        }
      })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
        staticClass: "pa-0 ma-0"
      }, [_c('v-card', {
        staticClass: "py-2 px-1",
        attrs: {
          "outlined": ""
        }
      }, [_c('v-text-field', {
        staticClass: "mx-1",
        attrs: {
          "outlined": "",
          "dense": "",
          "hide-details": "",
          "label": "Gruppenname"
        },
        model: {
          value: (item.text),
          callback: function($$v) {
            _vm.$set(item, "text", $$v)
          },
          expression: "item.text"
        }
      }), _vm._v(" "), _vm._l((item.bedingungen), function(bedingung, key, index) {
        return _c('v-row', {
          key: index,
          staticClass: "px-0 mx-0 py-2",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "px-1 mt-2",
          attrs: {
            "cols": "12"
          }
        }, [_c('v-autocomplete', {
          attrs: {
            "hide-details": "",
            "dense": "",
            "outlined": "",
            "items": _vm.kontaktfelder_system,
            "label": "Kontaktfeld"
          },
          model: {
            value: (bedingung.feld),
            callback: function($$v) {
              _vm.$set(bedingung, "feld", $$v)
            },
            expression: "bedingung.feld"
          }
        }), _vm._v(" " + _vm._s(item.bedingungen.status) + "\n                            ")], 1), _vm._v(" "), _c('v-col', {
          staticClass: "px-1 mb-2 mt-2",
          attrs: {
            "cols": "12"
          }
        }, [_c('v-combobox', {
          attrs: {
            "chips": "",
            "clearable": "",
            "deletable-chips": "",
            "multiple": "",
            "hide-details": "",
            "dense": "",
            "outlined": "",
            "label": "Werte",
            "append-outer-icon": "close"
          },
          on: {
            "click:append-outer": function($event) {
              return _vm.deleteBedingung(item, bedingung)
            }
          },
          model: {
            value: (bedingung.wert),
            callback: function($$v) {
              _vm.$set(bedingung, "wert", $$v)
            },
            expression: "bedingung.wert"
          }
        })], 1)], 1)
      }), _vm._v(" "), _c('v-btn', {
        attrs: {
          "block": "",
          "outlined": ""
        },
        on: {
          "click": function($event) {
            return _vm.addBedingung(item)
          }
        }
      }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
        attrs: {
          "block": "",
          "outlined": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteGruppe(index, item)
          }
        }
      }, [_vm._v("Gruppe löschen"), _c('v-icon', [_vm._v("delete")])], 1)], 2)], 1)], 1)
    }), 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "block": "",
        "text": ""
      },
      on: {
        "click": function($event) {
          return _vm.addGruppe(index)
        }
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v("Gruppe")], 1)], 1)], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-504a4d0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/Gruppen.vue
// module id = 777
// module chunks = 15